export const compareNullableNumber = (
    a: number | null | undefined,
    b: number | null | undefined
): number => {
    return (a ?? Number.MAX_SAFE_INTEGER) - (b ?? Number.MAX_SAFE_INTEGER);
};

export const compareByNullableNumber = <T>(
    selector: (value: T) => number | null | undefined
): ((a: T, b: T) => number) => {
    return (a, b) => compareNullableNumber(selector(a), selector(b));
};

export const compareNullableString = (
    a: string | null | undefined,
    b: string | null | undefined
): number => {
    if (a == null && b == null) {
        return 0;
    }

    if (a == null) {
        return 1;
    }

    if (b == null) {
        return -1;
    }

    return a.localeCompare(b);
};
